import React,{useState}  from 'react'
import {Box,Typography,Container,Button,Menu,MenuItem, CircularProgress} from '@mui/material'
import {useTheme,styled } from '@mui/material/styles'
import MoreIcon from '@mui/icons-material/MoreVert'
import {IconButton} from "@mui/material"
import Divider from '@mui/material/Divider';
import {useNavigate} from 'react-router-dom'
import { add_assessment, add_assessments, add_template,add_templates} from "../Redux/templatesSlice";
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Header from '../Components/Header'
import CustomDialog from '../Components/CustomDialog'
import {useSelector, useDispatch} from 'react-redux';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import ItemView from '../Components/ItemView';
import axios from 'axios'
import Snackbar from '@mui/material/Snackbar'
import { CalendarMonth,ArrowDropDownCircleOutlined, CopyAll, EditNote, Groups, Remove, Timelapse } from '@mui/icons-material';
import 'react-h5-audio-player/lib/styles.css';
import ReactPlayer from 'react-player'
import { Camera} from "react-use-camera";
import { add_job, add_jobs } from '../Redux/jobSlice'
import delete_job from '../Redux/reducers/delete_job'

const Accordion = styled((props) => (
	<MuiAccordion disableGutters elevation={4} square {...props} />
))(({ theme }) => ({
	'&:not(:last-child)': {
		borderBottom: 0,
	},
	'&:before': {
		display: 'none',
	},
	borderRadius:10,
	background:"black",
	margin:10
}));

const AccordionSummary = styled((props) => (
<MuiAccordionSummary
	expandIcon={<ArrowDropDownCircleOutlined sx={{ fontSize: 30 }} />}
	{...props}
/>
))(({ theme }) => ({
	background:theme.palette.mode === 'dark'? 'black': 'white',
	flexDirection: 'row',
	marginTop:10,
	marginBottom:10,
	height:150,
	'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
		transform: 'rotate(90deg)',
	},
	'& .MuiAccordionSummary-content': {
		marginLeft: theme.spacing(1),
		marginBottom: theme.spacing(1),
	}
}));
	
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(2),
	background:theme.palette.mode === 'dark'? 'black' : 'white',
}));

const ContainerBox = styled(Box, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 10,
    backgroundColor: '#100101'
  },
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 10
  },
//   background:"#100101",
  minHeight:100,
  maxHeight:300,
  justifyContent:"center",
  alignItems:"center",
  paddingBottom:20,
  marginBottom:40
}),
);

const QuestionBox = styled(Box, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 10,
    backgroundColor: '#100101'
  },
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 10
  },
  background:"#100101",
  minHeight:100,
  maxHeight:500,
  justifyContent:"center",
  alignItems:"center",
  paddingBottom:20,
  marginBottom:40,
  borderRadius:5
}),
)

const JobInfo = ()=>{

const theme = useTheme()
const [level, setLevel] = useState("");
const navigate = useNavigate()
const [loading, setLoading] = useState(false);
const [deleting, setDeleting] = useState(false);
const [del, setDel] = useState(false);
const [open, setOpen] = React.useState(false);
const [showModal, setShowModal] = React.useState(false);
const [isNext, setIsNext] = React.useState(false);
const [message, setMessage] = React.useState("");
const user = useSelector(state => state?.auth.user);
const job = useSelector(state => state?.job.job);
const jobs = useSelector(state => state?.job.jobs);
const [users, setUsers] = React.useState(job?.applicants || []);
const [anchorEl, setAnchorEl] = React.useState(null);
const [mobileAnchorEl, setMobileAnchorEl] = React.useState(null);
const [expanded, setExpanded] = React.useState(true);
const cameraRef = React.useRef(null);
const dispatch = useDispatch()

const isMenuOpen = Boolean(anchorEl);
const isApiMenuOpen = Boolean(mobileAnchorEl);

const menuId = 'primary-search-account-menu';
const mobileMenuId = 'primary-search-account-menu-mobile';

const handleMobileMenuClose = () => {
setMobileAnchorEl(null);
};

const handleMenuClose = () => {
setAnchorEl(null);
handleMobileMenuClose();
};

const handleMenuOpen = (event) => {
setAnchorEl(event?.currentTarget);
};

const handleChange = () => (event, newExpanded) => {
	setExpanded(newExpanded ? true : false);
};


const renderMenu = (
	<Menu
		anchorEl={anchorEl}
		anchorOrigin={{
		vertical: 'top',
		horizontal: 'right',
		}}
		id={menuId}
		keepMounted
		transformOrigin={{
		vertical: 'top',
		horizontal: 'right',
		}}
		open={isMenuOpen}
		onClose={handleMenuClose}
	>
	{
	(user?.email === job?.owner) && (
		<MenuItem sx={{width:250,height:40}} 
			onClick={async (e)=>{
				e?.preventDefault()

				const data = {
					id:job?.id,
					email:user?.email,
					
				}

				const token = user?.accessToken
				
				await delete_job(data,token,dispatch,add_job,add_jobs,jobs,setDeleting,setMessage,setOpen,navigate)
				handleMenuClose()
			}}>
				<IconButton
					size="large"
					aria-label="account of current user"
					aria-controls="primary-search-account-menu"
					aria-haspopup="true"
					color="inherit"
					disabled={deleting ? true : false}
					>
					{
						deleting ? <CircularProgress size={18} sx={{color:"#fff"}}/> : <Remove fontSize="small" sx={{color:"red"}}/>
					}
				</IconButton>
				<p style={{marginLeft:10,fontSize:12}}>Delete</p>
			</MenuItem>
			)
		}
		<MenuItem sx={{width:250,height:40}} 
			onClick={(e)=>{
				e?.preventDefault()
				navigate("/editJob")
				handleMenuClose()
			}}>
			<IconButton
				size="large"
				aria-controls="primary-search-account-menu"
				aria-haspopup="true"
				color="inherit"
				>
				<EditNote sx={{color:"yellow"}} fontSize="small"/>
			</IconButton>
			<p style={{marginLeft:10,fontSize:12}}>Edit job</p>
		</MenuItem>
	</Menu>
	);
	
const handleSnackbarOpen = ()=>{
	setOpen(true)
}

const handleSnackbarClose = ()=>{
	setOpen(false)
}

const DescriptionText = ({text,limit})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
	return <Typography color="white" ml={1} fontSize={13}> {displayText} </Typography>
  }

	return(
		<Box width="100%">
			<Header title="Create Assessment">
				<Breadcrumbs aria-label="breadcrumb">
					<Link  sx={{fontSize:12,color:"gray"}} underline="hover" color="inherit" href="/dashboard">
						Dashboard
					</Link>
					<Typography sx={{fontSize:12,color:"gray"}}>Job Info </Typography>
			</Breadcrumbs>			
			</Header>
			<Container>
				<Snackbar 
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}} 
					message={message} 
					onClose={handleSnackbarClose} 
					open={open} 
					autoHideDuration={2000}
				/>
				<Box sx={{borderRadius:5,padding:2,width:{xs:450,md:"100%",paddingLeft:1}}}>
					<Box display="flex" width="90%" flexDirection="row" justifyContent="space-between" alignItems="center">
						<Typography ml={5} style={{fontSize:16,fontWeight:400,fontFamily:"dinofans"}}>
						Job detail
						</Typography>
						<Box display="flex" flexDirection="row" justifyContent="center" alignItems="center">
							<Box sx={{display:{xs:"block",md:"flex"},flexDirection:{xs:"column",md:"row"}}}>
								<Button onClick={(e)=>{
									e?.preventDefault()
									dispatch(add_job(job))
									navigate("/jobTest")
								}} disabled sx={{backgroundColor:"#fff",color:"#000",fontSize:{xs:10,md:12},height:30,width:100,fontFamily:"dinofans",margin:1}} variant="contained">
									View
								</Button>
							{
								(user?.email === job?.owner ) && (
									<Button onClick={(e)=>{
										e?.preventDefault()
										dispatch(add_job(job))
										navigate("/jobReport")
									}} sx={{backgroundColor:"maroon",display:{xs:"none",md:"inline-block"},color:"#fff",fontSize:{xs:10,md:12},height:30,fontFamily:"dinofans",margin:1}} variant="contained">
										Report
									</Button>									
								)
							}
							</Box>
							{
								(user?.email === job?.owner ) && (
									<IconButton sx={{display:{xs:"none",md:"inline-block"}}}  onClick={handleMenuOpen}>
										<MoreIcon fontSize="small"/>
									</IconButton>
								)
							}
							{renderMenu}							
						</Box>

					</Box>
                    <Box display="flex" flexWrap="wrap" justifyContent="space-between" p={1} sx={{backgroundColor:"black"}}>
						<Box sx={{justifyContent:"center",alignItems:"center",textAlign:"center",width:"100%"}}>
							<img resizemode="cover" src={job?.enterprise_logo} width={80} height={80} style={{borderRadius:50,marginTop:5}}/>
						</Box>
						<Box sx={{padding:1,color:"gray",width:{md:"20%"}}}>
							<Typography sx={{fontFamily:"dinofans",fontSize:12}}>
								Title
							</Typography>
							<DescriptionText limit={100} text={job?.title} />
						</Box>
						<Box sx={{padding:1,color:"gray",width:{md:"20%"}}}>
							<Typography sx={{fontFamily:"dinofans",fontSize:12}}>
								Type
							</Typography>
							<DescriptionText limit={100} text={job?.type} />
						</Box>
						<Box sx={{padding:1,color:"gray",width:{md:"20%"}}}>
							<Typography sx={{fontFamily:"dinofans",fontSize:12}}>
								Category
							</Typography>
							<DescriptionText limit={100} text={job?.category} />
						</Box>
						<Box sx={{padding:1,color:"gray",width:{md:"20%"}}}>
							<Typography sx={{fontFamily:"dinofans",fontSize:12}}>
								Field
							</Typography>
							<DescriptionText limit={100} text={job?.field} />
						</Box>
						<Box sx={{padding:1,color:"gray",width:{md:"20%"}}}>
							<Typography sx={{fontFamily:"dinofans",fontSize:12}}>
								Location
							</Typography>
							<DescriptionText limit={100} text={job?.location} />
						</Box>
						<Box sx={{padding:1,color:"gray",width:{md:"20%"}}}>
							<Typography sx={{fontFamily:"dinofans",fontSize:12}}>
								Deadline
							</Typography>
							<Typography color="red" fontSize={14}>
								{job?.deadline}
							</Typography>
						</Box>
						<Box sx={{padding:1,color:"gray",width:{md:"20%"}}}>
							<Typography sx={{fontFamily:"dinofans",fontSize:12}}>
								Website
							</Typography>
							<Typography color="white" fontSize={14}>
								<a style={{color:"gold",textDecoration:"none"}} href={`${job?.enterprise_link}`}>
								{job?.enterprise_link ? job?.enterprise_link : "unavailable"}
								</a>
							</Typography>
						</Box>
						<Box sx={{padding:1,color:"gray",width:{md:"30%"}}}>
							<Typography sx={{fontFamily:"dinofans",fontSize:12}}>
								Organization name
							</Typography>
							<DescriptionText limit={100} text={job?.enterprise_name} />
						</Box>
						<Box sx={{padding:1,color:"gray",width:{md:"30%"}}}>
							<Typography sx={{fontFamily:"dinofans",fontSize:12}}>
							Organization email
							</Typography>
							<DescriptionText limit={100} text={job?.enterprise_email} />
						</Box>
						<Box sx={{padding:1,color:"gray",width:{md:"100%"}}}>
							<Typography sx={{fontFamily:"dinofans",fontSize:12}}>
								Job Description
							</Typography>
							<DescriptionText limit={300} text={job?.description} />
						</Box>
						<Box sx={{padding:1,color:"gray",width:{md:"50%"}}}>
							<Typography sx={{fontFamily:"dinofans",fontSize:12}}>
								Benefits
							</Typography>
							<ol>
								{
									job?.benefits?.map((itm,index)=>(
										<li style={{color:"#fff",fontSize:12}} key={index}>{itm}</li>
									))
								}
							</ol>
						</Box>
						<Box sx={{padding:1,color:"gray",width:{md:"50%"}}}>
							<Typography sx={{fontFamily:"dinofans",fontSize:12}}>
								Eligibilities
							</Typography>
							<ol>
								{
									job?.eligibilities?.map((itm,index)=>(
										<li style={{color:"#fff",fontSize:12}} key={index}>{itm}</li>
									))
								}
							</ol>
						</Box>
						<Box sx={{padding:1,color:"gray",width:{md:"100%"}}}>
							<Typography sx={{fontFamily:"dinofans",fontSize:12}}>
								Organization Description
							</Typography>
							<DescriptionText limit={300} text={job?.enterprise_description} />
						</Box>
					</Box>
				</Box>
				{/* <CustomDialog visible={showModal} deleting={del} setVisible={setShowModal} handleUserDelete={handleUserDelete} data={users.length > 0 ? users : assessment?.users}/> */}
			</Container>
		</Box>
		)
}

export default JobInfo